
import React from 'react';
import { Link } from 'react-router-dom';
import { FaBrain, FaComments, FaHandsHelping, FaSwimmer, FaMusic, FaUsers, FaWhatsapp } from 'react-icons/fa';
import SEO from '../components/SEO';
import { SEDES } from '../data/organizacion';
import { breadcrumb, servicio } from '../data/schema';

import psicologia from '../assets/img/tratamientos/psicologia.jpg'
import fono from '../assets/img/tratamientos/Fono.png'
import kine from '../assets/img/tratamientos/Kine.png'
import musi from '../assets/img/tratamientos/Musi.png'
import to from '../assets/img/tratamientos/TO.png'
import cocina from '../assets/img/tratamientos/Cocina.png'


const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/7KnDCOiB6qIcEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};

const Tratamientos = () => {
  const tratamientos = [
    {
      id: 1,
      title: "Psicología",
      description: "Abordaje individual para mejorar aspectos emocionales, cognitivos y conductuales, adaptado a las necesidades específicas de cada niño o joven. Trabajamos en coordinación con familias y otros profesionales.",
      icon: <FaBrain />,
      image: psicologia
    },
    {
      id: 2,
      title: "Fonoaudiología",
      description: "Evaluación y tratamiento de alteraciones del lenguaje, comunicación y deglución. Implementamos sistemas aumentativos y alternativos de comunicación para quienes lo requieren, facilitando su interacción con el entorno.",
      icon: <FaComments />,
      image: fono
    },
    {
      id: 3,
      title: "Terapia Ocupacional",
      description: "Desarrollo de habilidades para la vida diaria, buscando la mayor independencia posible. Trabajamos aspectos motores, sensoriales y cognitivos mediante actividades terapéuticas estructuradas.",
      icon: <FaHandsHelping />,
      image: to
    },
    {
      id: 4,
      title: "Kinesiología",
      description: "Tratamiento terapéutico basado en el movimiento y ejercicios adaptados, que favorece el desarrollo motor, mejora la coordinación y fortalece músculos y articulaciones. Se utiliza especialmente para estimular la independencia y mejorar la calidad de vida de niños y jóvenes con discapacidad.",
      icon: <FaSwimmer />,
      image: kine
    },
    {
      id: 5,
      title: "Musicoterapia",
      description: "Utilización de la música y sus elementos para facilitar la comunicación, el aprendizaje y la expresión emocional. Estimula el desarrollo cognitivo, social y emocional a través de experiencias musicales estructuradas.",
      icon: <FaMusic />,
      image: musi
    },
    {
      id: 6,
      title: "Terapia Grupal",
      description: "Espacios de interacción social donde se trabajan habilidades de comunicación, cooperación y resolución de conflictos. Proporciona un entorno seguro para practicar habilidades sociales y fortalecer vínculos.",
      icon: <FaUsers />,
      image: cocina
    }
  ];

  return (
    <div className="container">
      <SEO
        title="Tratamientos Individuales — Mi Lugar CET y CD"
        description={`${tratamientos.map((t) => t.title).join(', ')} para personas con discapacidad en Mi Lugar Temperley y Glew.`}
        path="/tratamientos"
        jsonLd={[
          breadcrumb([{ nombre: 'Tratamientos', path: '/tratamientos' }]),
          servicio({
            nombre: 'Tratamientos individuales',
            descripcion: 'Terapias individuales para niños y jóvenes con discapacidad, con plan personalizado y equipo interdisciplinario.',
            path: '/tratamientos',
            tipo: 'MedicalTherapy',
            ofrece: tratamientos.map((t) => ({ nombre: t.title, descripcion: t.description })),
          }),
        ]}
      />
      <div className="sede-header">
        <h1>Tratamientos Individuales</h1>
        <p>En Mi Lugar ofrecemos una amplia gama de tratamientos individuales, diseñados específicamente para atender las necesidades particulares de cada niño y joven.</p>
      </div>

      <section>
        <p className="text-center" style={{ marginBottom: '40px' }}>
          Nuestro enfoque terapéutico se basa en una evaluación integral que permite diseñar un plan de tratamiento personalizado. 
          Todos nuestros tratamientos son implementados por profesionales especializados, en coordinación con las familias 
          y otros miembros del equipo interdisciplinario.
        </p>

        <div className="treatment-container">
          {tratamientos.map(tratamiento => (
            <div key={tratamiento.id} className="treatment-card">
              <div className="treatment-image">
                <img src={tratamiento.image} alt={tratamiento.title} />
              </div>
              <div className="treatment-content">
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <div style={{ color: 'var(--primary-color)', fontSize: '1.5rem' }}>
                    {tratamiento.icon}
                  </div>
                  <h3>{tratamiento.title}</h3>
                </div>
                <p>{tratamiento.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-section" style={{ margin: '60px 0', padding: '40px', borderRadius: '10px' }}>
        <div className="cta-content">
          <h2>¿Necesitas más información sobre nuestros tratamientos?</h2>
          <p>Nuestro equipo profesional está disponible para responder todas tus preguntas y orientarte sobre el tratamiento más adecuado para tu hijo.</p>
          <div className="cta-buttons">
            <Link to="/contacto" className="btn">Consultar ahora</Link>
            <a href={SEDES[0].whatsapp} className="btn btn-accent">
              <FaWhatsapp /> Contactar por WhatsApp
            </a>
          </div>
        </div>
      </section>

       {/* WhatsApp Float Button With Report*/}
      <a
        href={SEDES[0].whatsapp}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Escribinos por WhatsApp"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion(SEDES[0].whatsapp);
        }}
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default Tratamientos;
